import { GET_PROCESSING_LINK,
    GET_PROCESSING_LINK_REQUEST,
    GET_PROCESSING_LINK_SUCCESS,
    SET_PROCESSING_LINK,
    SET_ORDER_PROPS,
    SELECT_DEPARTURE,
    ADD_ORDER_SUCCESS,
    ADD_ORDER_REQUEST,
    CHANGE_EMAIL,
    CHANGE_COUNT,
    SET_OPTIONS,
    CHANGE_OPTION_COUNT,
    CALCULATE,
    SAVE_CLIENT,
    SAVE_CLIENTS,
    SET_CLIENT,
    SAVE_CLIENT_SUCCESS,
    SAVE_CLIENT_REQUEST,
    CHANGE_CLIENT,
    SET_PAY_MODE,
    GET_ORDER_REQUEST,
    GET_ORDER_SUCCESS,
    GET_ORDER_FAILURE,
    GET_CLIENTS_REQUEST,
    GET_CLIENTS_SUCCESS,
    GET_CLIENTS_FAILURE,
    CLEAR_ORDER
} from '../actions/order';



const initialState = {
    tour: {},
    departure: {},
    props: {},
    order_promise: null,
    chronopay_promise: null,
    client: {
        
    },
    clients: [{}],
    user: {
        
    },
    count: 1,
    step: 0,
    type: 'chronopay',
    prepayment: 0,
    payment: 1,
    currency: 'RUR'
};

export default function order(state = initialState, action) {
    let total;
    let clients;
    switch (action.type) {
        case SET_ORDER_PROPS:
            if (action.payload.result) {
                return {...state, props: action.payload.result, order_promise: null, id: action.payload.result.order.id, step: 1};
            } else {
                return state;
            }
        case GET_PROCESSING_LINK_SUCCESS:
           //console.info('GET_PROCESSING_LINK_REQUEST');
            return {...state, chronopay_promise: action.req.json(), chronopay_info: {}};
        case GET_PROCESSING_LINK_REQUEST:
           //console.info('GET_PROCESSING_LINK_REQUEST');
            return {...state, chronopay_promise: null, chronopay_info: {}};
        case SET_PROCESSING_LINK:
            return {...state, chronopay_promise: null, chronopay_info: action.payload};
        case GET_ORDER_REQUEST:
            return {...state, isFetching: true};
        case GET_ORDER_FAILURE:
            return {...state, isFetching: false};
        case GET_ORDER_SUCCESS:
           //console.info(11111);
            return {...state, props: {...state.props, order: action.req.data}, isFetching: false, departure: action.req.data.departures[0], step: 1, id: action.req.data.id};
        case ADD_ORDER_REQUEST:
            return {...state, isFetching: true};
        case ADD_ORDER_SUCCESS:
            return {...state, order_promise: action.req.json(), isFetching: false};
        case SET_OPTIONS:
            return {...state, options: action.payload};
        case SET_PAY_MODE:
            return {...state, payment: action.payload.payment, prepayment: action.payload.prepayment};
        case SELECT_DEPARTURE:
            return {...state, departure: action.payload};
        case CHANGE_EMAIL:
            return {...state, user: {email: action.payload}};
        case CHANGE_COUNT:
            total = action.payload * state.departure.price;
            clients = [];
            for (let i = 0; i < action.payload; i++) {
                clients.push({});
            }

            return {...state, count: action.payload, total: total, clients: clients};
        case CHANGE_OPTION_COUNT:
            total = state.count * state.departure.price;

            let options = state.options;
            options.forEach(function(option){
                if (option.title == action.payload.option.title) {
                    option.count = parseInt(action.payload.count);
                    option.total = option.price * option.count;
                    if (option.count < 0) option.count = 0;
                }


                    total += option.total;
            });
            return {...state, options: options, total: total};
        case CALCULATE:
            total = state.count * state.departure.price;
            state.options.forEach(function(option){
                total += option.price * option.count;
            });
            return {...state, total: total};
        case SAVE_CLIENT_REQUEST:

            return {...state, client: {index: action.payload}};
        case SAVE_CLIENT_SUCCESS:
            return {...state, client: {...state.client, promise: action.req}};
        case SET_CLIENT:
            clients = state.clients;
            clients[state.client.index] = action.payload;
            return {...state, clients: clients, client: {promise: null}};
        case GET_CLIENTS_SUCCESS:
            return {...state, clients: action.req.data};
        case SAVE_CLIENTS:
            return {...state, step: 2};
        case CHANGE_CLIENT: {

            clients = state.clients;
            clients[action.payload.index][action.payload.key] = action.payload.value;
            return {...state, clients: clients};
            
        }

            return {...state, clients: clients};
        case CLEAR_ORDER: {
            return Object.assign({}, initialState);
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/common/reducers/order.js